import  useSubscriber  from "@root/hooks/useSubscriber";
import React, { createContext, useContext} from "react";

const defaultState: any = {};

const SubscriberContext = createContext<any>(defaultState);

export const SubscriberContextProvider: React.FC<
  SubscriberContextProviderProps
> = ({ children }) => {
  const data = useSubscriber();
  return (
    <SubscriberContext.Provider value={data}>
      {children}
    </SubscriberContext.Provider>
  );
};

export const useSubscriberContext = () => {
  return useContext(SubscriberContext);
};
